import { render, staticRenderFns } from "./user-management-roles.vue?vue&type=template&id=1490a2ea&"
import script from "./user-management-roles.vue?vue&type=script&lang=js&"
export * from "./user-management-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports